import { Notify } from '@flexisaf/flexibull2';
import { put, takeLatest } from 'redux-saga/effects';
import httpClient from 'utils/http-client';
import { handleError } from 'utils/utils';
import { editRatingFail, editRatingSuccess, fetchRatingStart } from '../actions';
import earlyYearsActionTypes from '../types';

export function* editRatingName({ payload }) {
  const { id, data } = payload;
  try {
    const response = yield httpClient.put(`/trait-configuration/trait-ratings/${id}`, data);
    yield put(editRatingSuccess(response.data));
    yield put(fetchRatingStart());
    Notify('Rating Name edited succesfully', { position: 'top-right' });
  } catch (error) {
    yield put(editRatingFail(error.fail));
    const err = handleError(error);
  }
}

export function* onEditRatingNameStart() {
  yield takeLatest(earlyYearsActionTypes.EDIT_RATING_START, editRatingName);
}
